function fetchIsle(locationName, url) {
    var reqJson = {
        locationName:locationName ?? null
    }

    $.ajax({
        async: false,
        url: url,
        data: reqJson,
        success: (data, msg) => {
            var text = `<option>- Select Or Create One -</option>`;

            $.each(data, (index, value) => {
                text += `<option value='${value.isle}'>${value.isle}</option>`
            })

            $("#isle").html(text)
        },
        error: (data, msg) => {
            console.log(data, msg)
        }
    })
}

function fetchRack(isle, url) {
    var reqJson = {
        isle:isle ?? null
    }

    $.ajax({
        async: false,
        url: url,
        data: reqJson,
        success: (data, msg) => {
            var text = `<option>- Select Or Create One -</option>`;

            $.each(data, (index, value) => {
                text += `<option value='${value.rack}'>${value.rack}</option>`
            })

            $("#rack").html(text)
        },
        error: (data, msg) => {
            console.log(data, msg)
        }
    })
}

function fetchBin(isle, url) {
    var reqJson = {
        isle:isle ?? null
    }

    $.ajax({
        async: false,
        url: url,
        data: reqJson,
        success: (data, msg) => {
            var text = `<option>- Select Or Create One -</option>`;

            $.each(data, (index, value) => {
                text += `<option value='${value.bin}'>${value.bin}</option>`
            })

            $("#bin").html(text)
        },
        error: (data, msg) => {
            console.log(data, msg)
        }
    })
}




$(document).ready(function() {
    $('#warehouseFilter').change(function() {
        var warehouseId = $(this).val();
        $.ajax({
            url: "{{ route('warehouse-location.filter')}}",
            type: "post",
            data: { warehouseId: warehouseId,_token: '{{ csrf_token() }}' },
            success: function(response) {
                var html = '';
                $('#warehouseFilter').val('');
                if (!$.isEmptyObject(response)) {
                    $.each(response, function(index, location) {
                        html += `<tr class="gradeA">
                            <td>${location.name}</td>
                            <td>${location.warehouse ? location.warehouse.name : ''}</td>
                            <td>${location.isle}</td>
                            <td>${location.rack}</td>
                            <td>${location.bin}</td>
                            <td class="align-middle">
                                <div class="mt-sm-0 mt-2 dropdown-toggle">
                                    @if (Gate::any(['edit location', 'delete location']))
                                        <a href="#" data-bs-toggle="dropdown" class="text-dark text-decoration-none">Actions <b class="caret"></b></a>
                                        <div class="dropdown-menu">
                                            @can('edit location')
                                                <a class="dropdown-item" href="location/edit/${location.id}">Edit</a>
                                            @endcan
                                            @can('delete location')
                                                <div role="separator" class="dropdown-divider"></div>
                                                <a class="dropdown-item delete-location" data-id="${location.id}" href="location/delete/${location.id}">{{__('common.delete')}}</a>
                                            @endcan
                                        </div>
                                    </div>
                                @endif
                            </td>
                        </tr>`;
                    });
                } else {
                    html += `<tr class="gradeA">
                        <td colspan="6" class="text-center">No record found</td>
                    </tr>`;
                }

                $('#filter-data').html(html);
            },

            error: function(error) {
                console.error('Error fetching filtered content: ', error);
            }
        });
    });
});
